import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { createSelector } from 'reselect';

export const getSelectedItems = createSelector(
    SelectionsSelectors.getSelectedIdxs,
    (state) => state,
    (ids, state) => ids.map((id) => getItemById(state, id))
);
